const IMAGE_BASE_URL = process.env.REACT_APP_IMAGE_API_URL;

/**
 * Widths that used to be baked into the pre-generated ProductImage variants. Requesting them as query
 * parameters means one stored original can serve every context.
 */
export const ImageWidth = {
  small: 93,
  thumbnail: 134,
  medium: 285,
  zoom: 490,
} as const;

export type ImageUrlOptions = {
  width?: number;
  quality?: number;
};

/**
 * Builds an absolute image URL from the relative path the API stores (e.g. "Files/ho/Images/Manufacturing/...").
 *
 * Sizing parameters use Bunny Optimizer's spelling; the API's own image middleware accepts the same names, so
 * call sites do not change when delivery moves to the CDN. Returns an empty string for a missing path so callers
 * can fall back to a placeholder rather than requesting ".../undefined".
 */
export const getImageUrl = (path?: string | null, options?: ImageUrlOptions): string => {
  if (!path) {
    return '';
  }

  const url = `${IMAGE_BASE_URL}/${path.replace(/^\/+/, '')}`;

  if (!options?.width) {
    return url;
  }

  const params = new URLSearchParams();
  params.set('width', String(options.width));
  params.set('quality', String(options.quality ?? 80));

  return `${url}?${params.toString()}`;
};
